import { createAsyncThunk } from "@reduxjs/toolkit"
import AxiosClient from "../AxiosClient"

export const getAllRuleListAsync = createAsyncThunk(
  'ruleBuilder/getAllRuleListAsync',
  async (payload: {platform_id?: number | null; page?: number; limit?: number; sort_by?: string; sort_order?: string; search?: string; }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/platform-workflow-rule`,
      undefined,
      toolkit,
      payload
    )
  }
)

export const getGetEditDataAsync = createAsyncThunk(
  'ruleBuilder/getEditRuleAsync',
  async (payload: { ruleId: number }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/platform-workflow-rule?platform_workflow_id=${payload.ruleId}`,
      null,
      toolkit,
      []
    )
  }
)

export const getEventListAsync = createAsyncThunk(
  'ruleBuilder/getEventListAsync',
  async (payload: { platformId: number | string }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/available-workflow-event?platform_id=${payload.platformId}`,
      null,
      toolkit,
      []
    )
  }
)

export const getTriggerListAsync = createAsyncThunk(
  'ruleBuilder/getTriggerListAsync',
  async (payload: { evenId: number }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/available-workflow-event-trigger?available_workflow_event_id=${payload.evenId}`,
      null,
      toolkit,
      []
    )
  }
)

export const getConditionListAsync = createAsyncThunk(
  'ruleBuilder/getConditionListAsync',
  async (payload: { triggerId: number, platformId: number | string }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/available-workflow-event-condition?available_workflow_event_id=${payload.triggerId}&platform_id=${payload.platformId}`,
      null,
      toolkit,
      []
    )
  }
)

export const getActionListAsync = createAsyncThunk(
  'ruleBuilder/getActionListAsync',
  async (payload: { triggerId: number, platformId: number | string }, toolkit) => {
    return await AxiosClient(
      'GET',
      `/api/available-workflow-event-action?available_workflow_event_id=${payload.triggerId}&platform_id=${payload.platformId}`,
      null,
      toolkit,
      []
    )
  }
)

export const createRuleAsync = createAsyncThunk(
  'ruleBuilder/createRuleAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient(
      'POST',
      `/api/platform-workflow-rule`,
      payload,
      toolkit,
      []
    )
  }
)

export const updateRuleAsync = createAsyncThunk(
  'ruleBuilder/updateRuleAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient(
      'PUT',
      `/api/platform-workflow-rule`,
      payload,
      toolkit,
      []
    )
  }
)

export const deleteRuleAsync = createAsyncThunk(
  'ruleBuilder/deleteRuleAsync',
  async (payload: { ruleId: number }, toolkit) => {
    return await AxiosClient(
      'DELETE',
      `/api/platform-workflow-rule?platform_workflow_id=${payload.ruleId}`,
      [],
      toolkit,
      []
    )
  }
)

// ---------------- All Secondary Platform ----------------
export const getAllSecondaryPlatformListAsync = createAsyncThunk(
  'ruleBuilder/getAllSecondaryPlatformListAsync',
  async (_, thunkAPI) => {
    try {
      console.log("I am hit secondary")
      const response = await AxiosClient('GET', '/api/all-secondary-platform', null, thunkAPI, {});
      return response; // payload is the API data
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);

// ---------------- All Non-Secondary Platform ----------------
export const getAllNonSecondaryPlatformListAsync = createAsyncThunk(
  'ruleBuilder/getAllNonSecondaryPlatformListAsync',
  async (_, thunkAPI) => {
    try {
      const response = await AxiosClient('GET', '/api/all-non-secondary-platform', null, thunkAPI, {});
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);
// ---------------- All Multiselect List for inventory location Platform ----------------
export const getAllInventoryLocationPlatformListAsync = createAsyncThunk(
  'ruleBuilder/getAllInventoryLocationPlatformListAsync',
  async (_, thunkAPI) => {
    try {
      const response = await AxiosClient('GET', '/api/all-inventory-location', null, thunkAPI, {});
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);
// ---------------- All Action Code get select multiselect api ----------------
export const getSelectMultiselectByActionCodeAsync = createAsyncThunk(
  'ruleBuilder/getSelectMultiselectByActionCodeAsync',
  async (payload: {
    actionCode: string;
    fieldCode?: string;
    selectedValue?: string | number;
    search?: string;
    limit?: number;
    page?: number;
    platformId?: number | string;
  }, thunkAPI) => {
    try {
      const params = new URLSearchParams({ action_code: payload.actionCode })
      if (payload.fieldCode) params.set('field_code', payload.fieldCode)
      if (payload.selectedValue !== undefined && payload.selectedValue !== '') {
        params.set('selected_value', String(payload.selectedValue))
      }
      if (payload.limit) params.set('limit', String(payload.limit))
      if (payload.page) params.set('page', String(payload.page))
      if (payload.search?.trim()) params.set('search', payload.search.trim())
      if (payload.platformId) params.set('platform_id', String(payload.platformId))
      const response = await AxiosClient(
        'GET',
        `/api/workflow-action-code-data?${params.toString()}`,
        null,
        thunkAPI,
        {}
      );
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);

// ---------------- Condition code select data ----------------
export const getConditionCodeDataAsync = createAsyncThunk(
  'ruleBuilder/getConditionCodeDataAsync',
  async (payload: {
    conditionCode: string;
    fieldCode: string;
    selectedValue?: string | number;
    search?: string;
    limit?: number;
    page?: number;
    platformId?: number | string;
  }, thunkAPI) => {
    try {
      const params = new URLSearchParams({
        condition_code: payload.conditionCode,
        field_code: payload.fieldCode,
      })
      if (payload.limit) params.set('limit', String(payload.limit))
      if (payload.page) params.set('page', String(payload.page))
      if (payload.search?.trim()) params.set('search', payload.search.trim())
      if (payload.platformId) params.set('platform_id', String(payload.platformId))
      if (
        payload.selectedValue !== undefined &&
        payload.selectedValue !== null &&
        payload.selectedValue !== ''
      ) {
        params.set('selected_value', String(payload.selectedValue))
      }
      const response = await AxiosClient(
        'GET',
        `/api/workflow-conditions-code-data?${params.toString()}`,
        null,
        thunkAPI,
        {}
      );
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);
